'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['box', 'container', 'icon', 'textContainer', 'text', 'deleteButton'];
var baseStyle = function baseStyle(props) {
  var width = props.width,
    isLoading = props.isLoading,
    assetLike = props.assetLike;
  var box = {
    display: 'inline-block',
    width: width,
    position: 'relative'
  };
  var container = _objectSpread(_objectSpread({
    lineHeight: 1,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bg: 'gray.100',
    color: 'gray.200',
    cursor: 'default',
    /*
     * It is not a link if there's no `href`, so style accordingly.
     * Hover effects are disabled until it has a `href`.
     */
    '&[href]': {
      cursor: 'pointer',
      color: 'blue.400'
    },
    _groupDisabled: {
      color: 'gray.200'
    },
    borderTopRightRadius: 'sm',
    borderTopLeftRadius: 'sm'
  }, !(assetLike.title || assetLike.filename) && {
    borderBottomLeftRadius: 'sm',
    borderBottomRightRadius: 'sm'
  }), {}, {
    transitionProperty: 'common',
    transitionDuration: 'normal'
  });
  var icon = {
    /*
     * Icon and margin is sized relative to the component's width.
     *
     * The margin gives a bit of breathing room. By setting it in percent,
     * it will always scale automagically with the same proportions, no matter
     * the size of the component.
     */
    width: "40%",
    /**
     * The {@link Spinner} is a bit smaller than the {@link Draft} icon,
     * so we need to adjust the margin.
     */
    mx: 'auto',
    my: isLoading ? "28.25%" : "25%",
    display: 'block',
    transitionProperty: 'common',
    transitionDuration: 'normal'
  };
  var deleteButton = {
    position: 'absolute',
    top: 0,
    right: 0,
    p: 1,
    '& > svg': {
      display: "block"
    },
    color: 'blue.400',
    _disabled: {
      color: 'gray.300',
      display: 'none'
    },
    _hover: {
      color: 'blue.500'
    },
    zIndex: "docked"
  };
  var textContainer = {
    display: 'block',
    px: "6.25%",
    py: "4%",
    bg: 'gray.200',
    borderBottomLeftRadius: 'sm',
    borderBottomRightRadius: 'sm'
  };
  var text = {
    fontSize: 'sm',
    m: 0
  };
  return {
    box: box,
    container: container,
    icon: icon,
    deleteButton: deleteButton,
    textContainer: textContainer,
    text: text
  };
};
var File = {
  baseStyle: baseStyle,
  parts: parts
};
exports["default"] = File;